import React from 'react';

const inputCls = "w-full h-10 px-3 rounded-xl bg-[#F6F7FB] border border-[#EFF0F6] text-[13.5px] focus:bg-white focus:border-[#4F46E5] outline-none";
const monoCls = inputCls + " font-mono tracking-wider";
const labelCls = "block text-[12px] font-semibold text-[#4A4B63] mb-1";

/**
 * Identity section — name, SIRET, SIREN, legal_form, NAF, sector, employees,
 * capital_social, leader_name, leader_role.
 * Extracted from CompanyFormDialog (Vague 97.4).
 */
export default function CompanyIdentitySection({ values, set }) {
  return (
    <section>
      <h3 className="text-[11.5px] font-semibold text-[#6B6C85] mb-2 tracking-wide uppercase">Identité</h3>
      <div className="grid grid-cols-2 gap-3">
        <div className="col-span-2">
          <label className={labelCls}>Raison sociale *</label>
          <input required data-testid="company-form-name" value={values.name} onChange={set('name')} className={inputCls} />
        </div>
        <div>
          <label className={labelCls}>SIRET</label>
          <input value={values.siret} onChange={set('siret')} className={monoCls} />
        </div>
        <div>
          <label className={labelCls}>SIREN</label>
          <input value={values.siren} onChange={set('siren')} className={monoCls} />
        </div>
        <div>
          <label className={labelCls}>Forme juridique</label>
          <input data-testid="company-legal-form" value={values.legal_form} onChange={set('legal_form')} className={inputCls} placeholder="SAS, SARL, SA…" />
        </div>
        <div>
          <label className={labelCls}>Code NAF / APE</label>
          <input value={values.naf_code} onChange={set('naf_code')} className={inputCls + " font-mono"} placeholder="62.01Z" />
        </div>
        <div>
          <label className={labelCls}>Secteur d'activité</label>
          <input value={values.sector} onChange={set('sector')} className={inputCls} />
        </div>
        <div>
          <label className={labelCls}>Effectif</label>
          <input type="number" value={values.employees_count} onChange={set('employees_count')} className={inputCls} />
        </div>
        <div>
          <label className={labelCls}>Capital social (€)</label>
          <input type="number" data-testid="company-capital-social" value={values.capital_social} onChange={set('capital_social')} className={inputCls} />
        </div>
        <div>
          <label className={labelCls}>Dirigeant (nom)</label>
          <input data-testid="company-leader-name" value={values.leader_name} onChange={set('leader_name')} className={inputCls} />
        </div>
        <div>
          <label className={labelCls}>Qualité (dirigeant)</label>
          <input data-testid="company-leader-role" value={values.leader_role} onChange={set('leader_role')} className={inputCls} placeholder="Président·e, DG…" />
        </div>
      </div>
    </section>
  );
}
